import { Box, Skeleton, Stack } from '@ethings/ui-toolkit';
import { FC } from 'react';

export const ThingEventsSkeleton: FC = () => (
  <Stack spacing={2}>
    <Skeleton height={44} variant="rounded" width={170} />
    <Stack spacing={1.5}>
      {Array.from({ length: 5 }, (_, index) => (
        <Stack key={index} alignItems="center" direction="row" spacing={2}>
          <Stack alignItems="center" spacing={0.75}>
            <Skeleton height={index === 0 || index === 4 ? 24 : 16} variant="circular" width={index === 0 || index === 4 ? 24 : 16} />
            {index < 4 && <Skeleton height={34} variant="rounded" width={2} />}
          </Stack>
          <Box
            style={{
              border: '1px solid rgba(0, 0, 0, 0.12)',
              borderRadius: 8,
              flex: 1,
              padding: '10px 12px',
            }}
          >
            <Stack spacing={0.75}>
              <Stack alignItems="center" direction="row" justifyContent="space-between">
                <Skeleton height={20} variant="text" width={index % 2 ? '36%' : '48%'} />
                <Skeleton height={18} variant="text" width={56} />
              </Stack>
              <Skeleton height={18} variant="text" width={index % 2 ? '70%' : '56%'} />
            </Stack>
          </Box>
        </Stack>
      ))}
    </Stack>
  </Stack>
);

